import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import type { IProModalCustomStyles } from "pro-features/components/Modals/src/ProModal";

export const StyledTitle = styled.h3`
    ${setFontVariant("h5", colorsPalettes.carbon[500])}

    line-height: 24px;
    margin: 0;
`;

export const StyledImageContainer = styled.div`
    width: 130px;
    height: 130px;
    margin: 17px auto;
`;

export const StyledModalFooter = styled.div`
    display: inline-flex;
    width: 100%;
    justify-content: flex-end;
`;

export const modalStyles: IProModalCustomStyles = {
    content: {
        padding: "20px 16px 16px 20px",
        display: "flex",
        flexDirection: "column",
    },
};
